import React from 'react';
import { styled } from '@mui/material/styles';
import Slider, { SliderThumb } from '@mui/material/Slider';
import scorecolors from '../../styles/scoreColors';
import clsx from 'clsx';
import { get } from '../../lib/lodash';

const Container = styled('div')({
  position: 'relative',
});

const SliderLabel = styled('div', {
  shouldForwardProp: (prop) => prop !== 'right',
})(({ right }) => ({
  fontSize: 14,
  position: 'absolute',
  bottom: -20,
  ...(right ? { right: -16 } : { left: -16 }),
}));

const SliderWithStyles = styled(Slider)(({ theme }) => ({
  root: {
    color: theme.palette.text.disabled,
    height: 3,
    padding: '13px 0',
  },
  '& .MuiSlider-thumb': {
    height: 40,
    width: 40,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[4],

    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: theme.shadows[2],
    },

    '& .value': {
      fontSize: 12,
      color: theme.palette.common.white,
    },

    '&.thumb-1': {
      backgroundColor: scorecolors.score10,
    },
    '&.thumb-0': {
      backgroundColor: scorecolors.score0,
    },
  },
  active: {},
  '& .MuiSlider-track': {
    height: 0,
    color: theme.palette.text.disabled,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.text.disabled,
    opacity: 1,
    height: 3,
  },
}));

const ThumbComponent = (props) => {
  const { children, ...other } = props;

  const di = get(props, 'data-index');
  const value = get(props, `ownerState.value.${di}`);

  return (
    <SliderThumb {...other} className={clsx(props.className, `thumb-${di}`)}>
      {children}
      <span className="value">{value}</span>
    </SliderThumb>
  );
};

export const ColorSlider = (props) => {
  return (
    <Container>
      <SliderWithStyles {...props} slots={{ thumb: ThumbComponent }} />
      <SliderLabel>Low</SliderLabel>
      <SliderLabel right>High</SliderLabel>
    </Container>
  );
};
